import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import validator from 'validator';
import InputText from '../../Components/Commons/InputText/InputText';
import { BASE_URL } from '../../Config';
import { Button, Image } from 'antd';
import { userLogin } from '../../Redux/Features/userLoginSlice';
import styles from './Login.module.scss';
import UnAuthLayout from '../../Layouts/UnAuthLayout/UnAuthLayout';
import { removeCookie, setCookie } from '../../utils/helper';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state?.userLogin);
  const [clientError, setClientError] = useState({});
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const setFeild = (feildName, feildValue) => {
    setFormData({ ...formData, [feildName]: feildValue });
  };

  const handleSubmit = async () => {
    let isErr = false;
    let errors = {};

    if (!validator.isEmail(formData?.email)) {
      isErr = true;
      errors.email = 'Email is invalid';
    }
    if (!validator.isLength(formData?.password, { min: 6 })) {
      isErr = true;
      errors.password = 'Password should be 6 or more characters long';
    }
    if (validator.isEmpty(formData?.email)) {
      isErr = true;
      errors.email = 'Email is required';
    }
    if (validator.isEmpty(formData?.password)) {
      isErr = true;
      errors.password = 'Password is required';
    }

    if (isErr) {
      isErr = false;
      setClientError(errors);
    } else {
      setClientError({});
      const data = {
        data: {
          ...formData,
        },
        navigate,
        onSuccess: () => {
          setFormData({
            email: '',
            password: '',
          });
        },
      };
      dispatch(userLogin(data));
    }
  };

  const handleGoogle = () => {
    window.open(`${BASE_URL}/api/auth/google`, '_self');
  };

  const handleRemeberMe = (isRemember) => {
    if (isRemember) {
      setCookie('remember', isRemember);
    } else {
      removeCookie('remember');
    }
  };

  useEffect(() => {
    removeCookie('remember');
  }, []);

  return (
    <UnAuthLayout>
      <div className={styles.main_login_container}>
        <h1>Log In</h1>
        <p></p>
        <div className={styles.login_form_container}>
          <div className={styles.input_container}>
            <InputText
              label={'Email address'}
              error={clientError?.email ? clientError?.email : false}
              value={formData?.email}
              size={'large'}
              onChange={(e) => setFeild('email', e?.target?.value)}
            />
            <InputText
              label={'Password'}
              size={'large'}
              type={'password'}
              error={clientError?.password ? clientError?.password : false}
              value={formData?.password}
              onChange={(e) => setFeild('password', e?.target?.value)}
            />
          </div>
          <div className={styles.saved_and_account_container}>
            <div className={styles.remember}>
              <InputText size={'small'} type={'checkbox'} onChange={(e) => handleRemeberMe(e?.target?.checked)} />
              <span>Remember me</span>
            </div>
            <div className={styles.have_and_account}>
              <span>
                Don't have an account?<Link to={`/register`}>Create free account</Link>
              </span>
            </div>
          </div>
          <div className={styles.button_container}>
            <Button onClick={handleSubmit} disabled={isLoading} loading={isLoading} type="primary" size="large" block>
              Log In
            </Button>
          </div>
          <div className={styles.forgot_password_container}>
            <Link to={`/forgot-password-request`}>Forgot Password ?</Link>
          </div>
        </div>
        <div className={styles.google_login_button}>
          <Button onClick={handleGoogle} size="large" block>
            <Image preview={false} src={'/Assets/auth/google_logo.svg'} /> <span>Log In with Google</span>
          </Button>
        </div>
      </div>
    </UnAuthLayout>
  );
};

export default Login;
